/**
 * Tema Polo Sul Climatização
 * Script Principal
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // ==========================================
  // MOBILE MENU TOGGLE
  // ==========================================
  const menuToggle = document.getElementById('MobileMenuToggle');
  const menuClose = document.getElementById('MobileMenuClose');
  const mobileMenu = document.getElementById('MobileMenu');

  if (menuToggle && mobileMenu) {
    const closeMobileMenu = () => {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden'; // Evita scroll atrás
    });

    if (menuClose) menuClose.addEventListener('click', closeMobileMenu);

    mobileMenu.querySelectorAll('[data-mobile-menu-close], a').forEach((el) => {
      el.addEventListener('click', closeMobileMenu);
    });
  }

  // ==========================================
  // AJAX CART DRAWER
  // ==========================================
  class CartDrawer {
    constructor() {
      this.drawer = document.getElementById('CartDrawer');
      this.overlay = document.getElementById('CartDrawerOverlay');
      this.closeBtn = document.getElementById('CartDrawerClose');
      this.contentWrapper = document.getElementById('CartDrawerContent');
      this.countEl = document.getElementById('CartDrawerCount');
      this.totalEl = document.getElementById('CartDrawerTotal');
      this.freeShippingTextEl = document.getElementById('CartDrawerFreeShippingText');
      this.freeShippingBarEl = document.getElementById('CartDrawerFreeShippingBar');
      this.whatsappLinks = document.querySelectorAll('[data-cart-whatsapp-link]');
      this.whatsappNumber = (this.drawer?.dataset.whatsappNumber || '').replace(/\D/g, '');
      this.freeShippingThreshold = 200000;
      
      if(!this.drawer) return;

      this.initEventListeners();
      this.interceptAddForms();
    }

    initEventListeners() {
      // Fechar Drawer
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());

      document.addEventListener('click', (e) => {
        const closeTrigger = e.target.closest('[data-cart-drawer-close]');
        if (closeTrigger || e.target.id === 'CartDrawerOverlay') {
          e.preventDefault();
          this.close();
        }
      });

      // Quantidade/Remover no Drawer
      this.drawer.addEventListener('click', (e) => {
        if(e.target.classList.contains('drawer-remove-btn')) {
          e.preventDefault();
          this.changeItemQuantity(e.target.dataset.key, 0);
        }
        else if(e.target.classList.contains('drawer-qty-btn')) {
          e.preventDefault();
          const key = e.target.dataset.key;
          const currentQty = parseInt(e.target.parentNode.querySelector('span').innerText);
          const newQty = e.target.dataset.action === 'plus' ? currentQty + 1 : currentQty - 1;
          this.changeItemQuantity(key, newQty);
        }
      });
    }

    open() {
      document.body.classList.add('cart-drawer-open');
      document.body.style.overflow = 'auto';

      if (this.overlay) {
        this.overlay.style.opacity = '1';
        this.overlay.style.visibility = 'visible';
        this.overlay.style.pointerEvents = 'auto';
      }

      if (this.drawer) {
        this.drawer.style.transform = 'translateX(0)';
        this.drawer.style.visibility = 'visible';
        this.drawer.style.display = 'flex';
      }
      this.updateCartHtml(); // Atualiza toda vez que abre para garantir consistência
    }

    close() {
      document.body.classList.remove('cart-drawer-open');
      document.body.style.overflow = '';

      if (this.overlay) {
        this.overlay.style.opacity = '0';
        this.overlay.style.visibility = 'hidden';
        this.overlay.style.pointerEvents = 'none';
      }

      if (this.drawer) {
        this.drawer.style.transform = 'translateX(100%)';
        this.drawer.style.visibility = 'visible';
        this.drawer.style.display = 'flex';
      }
    }

    showLoading() {
      const loader = this.drawer.querySelector('.cart-drawer__loading');
      if(loader) loader.style.display = 'flex';
    }

    hideLoading() {
      const loader = this.drawer.querySelector('.cart-drawer__loading');
      if(loader) loader.style.display = 'none';
    }

    // Intercepta forms de "Add to cart"
    interceptAddForms() {
      const forms = document.querySelectorAll('form[action$="/cart/add"]');
      forms.forEach(form => {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          
          // Disable button
          const btn = form.querySelector('[type="submit"]');
          const originalText = btn.innerHTML;
          btn.innerHTML = 'Adicionando...';
          btn.disabled = true;

          const formData = new FormData(form);
          
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData
          })
          .then(response => response.json())
          .then(data => {
            this.open();
          })
          .catch((error) => {
            console.error('Error:', error);
            alert('Erro ao adicionar produto ao carrinho.');
          })
          .finally(() => {
            btn.innerHTML = originalText;
            btn.disabled = false;
          });
        });
      });
    }

    changeItemQuantity(key, quantity) {
      this.showLoading();
      
      const body = JSON.stringify({
        id: key,
        quantity: quantity
      });

      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body
      })
      .then(response => response.json())
      .then(state => {
        this.updateCartHtml();
      })
      .catch((error) => {
        console.error('Error:', error);
        this.hideLoading();
      });
    }

    // Atualiza o HTML usando Section Rendering do Shopify
    updateCartHtml() {
      this.showLoading();

      // Pegamos o carrinho formatado do server
      fetch(window.Shopify.routes.root + '?section_id=cart-drawer-content')
      .then(response => response.text())
      .then(text => {
        // Criar um DOM dummy para extrair os pedaços (ou podemos recriar o JSON, mas via section é mais limpo se tiver o arquivo section/cart-drawer-content.liquid configurado. 
        // Como não criamos um section separado só pra o conteudo, faremos um fetch do JSON e montamos manual ou damos refresh na pagina (fallback simples))
        
        return fetch(window.Shopify.routes.root + 'cart.js');
      })
      .then(r => r.json())
      .then(cart => {
        this.renderCartFromJSON(cart);
        this.hideLoading();
      })
      .catch((error) => {
        console.error('Error:', error);
        this.hideLoading();
        this.close();
        window.location.href = window.Shopify.routes.root + 'cart';
      });
    }

    formatMoney(cents) {
      return 'R$ ' + (cents / 100).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    }

    updateCommercialMessages(cart) {
      const total = cart.total_price || 0;
      const remaining = Math.max(this.freeShippingThreshold - total, 0);
      const progress = Math.min(Math.round((total / this.freeShippingThreshold) * 100), 100);

      if (this.freeShippingTextEl) {
        this.freeShippingTextEl.innerText = remaining > 0
          ? `Faltam ${this.formatMoney(remaining)} para frete grátis em Goiânia e região.`
          : 'Frete grátis liberado para Goiânia e região.';
      }

      if (this.freeShippingBarEl) {
        this.freeShippingBarEl.style.width = `${progress}%`;
      }

      if (this.whatsappNumber && this.whatsappLinks.length) {
        const itemList = cart.items.map(item => `${item.quantity}x ${item.product_title}`).join(', ');
        const message = `Olá! Quero ajuda para finalizar minha compra na Polo Sul. Itens: ${itemList || 'carrinho vazio'}. Total: ${this.formatMoney(total)}.`;
        const href = `https://wa.me/55${this.whatsappNumber}?text=${encodeURIComponent(message)}`;
        this.whatsappLinks.forEach(link => {
          link.href = href;
        });
      }
    }

    // Renderiza o drawer baseado no JSON do carrinho
    renderCartFromJSON(cart) {
      // Atualiza counts
      this.countEl.innerText = cart.item_count;
      // Atualiza badge no header
      const headerCounts = document.querySelectorAll('.cart-count-bubble, .cart-count');
      headerCounts.forEach(el => el.innerText = cart.item_count);

      this.totalEl.innerText = this.formatMoney(cart.total_price);
      this.updateCommercialMessages(cart);

      // Itens
      let html = '';
      if(cart.item_count === 0) {
        html = `
          <div style="text-align: center; margin-top: 32px;">
            <p style="color: var(--color-text-muted); margin-bottom: 16px;">Seu carrinho está vazio.</p>
            <button type="button" data-cart-drawer-close class="btn btn--secondary">Continuar comprando</button>
          </div>
        `;
      } else {
        html = '<div style="display: flex; flex-direction: column; gap: 16px;">';
        cart.items.forEach(item => {
          const img = item.image ? `<img src="${item.image}" alt="${item.title}" style="width: 100%; height: 100%; object-fit: contain;">` : '';
          html += `
            <div style="display: flex; gap: 12px; padding-bottom: 16px; border-bottom: 1px solid var(--color-border);">
              <div style="width: 80px; height: 80px; border-radius: 4px; border: 1px solid var(--color-border); padding: 2px;">
                ${img}
              </div>
              <div style="flex: 1;">
                <a href="${item.url}" style="color: var(--color-text); text-decoration: none; font-weight: bold; font-size: 0.875rem; line-height: 1.2; display: block; margin-bottom: 4px;">${item.product_title}</a>
                <div style="color: var(--color-primary); font-weight: bold; margin-bottom: 8px;">${this.formatMoney(item.original_line_price)}</div>
                
                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <div style="display: flex; align-items: center; border: 1px solid var(--color-border); border-radius: 4px; overflow: hidden;">
                    <button type="button" class="drawer-qty-btn" data-action="minus" data-key="${item.key}" style="padding: 2px 8px; background: transparent; border: none;">-</button>
                    <span style="padding: 2px 8px; font-size: 0.875rem;">${item.quantity}</span>
                    <button type="button" class="drawer-qty-btn" data-action="plus" data-key="${item.key}" style="padding: 2px 8px; background: transparent; border: none;">+</button>
                  </div>
                  <button type="button" class="drawer-remove-btn" data-key="${item.key}" style="background: transparent; border: none; color: var(--color-error); font-size: 0.75rem; text-decoration: underline; cursor: pointer;">Remover</button>
                </div>
              </div>
            </div>
          `;
        });
        html += '</div>';
      }

      // Evita piscar o loading sumindo
      const loaderHtml = `
        <div class="cart-drawer__loading" style="display: none; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255,255,255,0.8); z-index: 10; align-items: center; justify-content: center;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--color-primary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="animation: spin 1s linear infinite;">
            <line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
          </svg>
        </div>
      `;

      this.contentWrapper.innerHTML = loaderHtml + html;
    }
  }

  // Init global para poder ser chamado por outros scripts
  window.cartDrawer = new CartDrawer();

  // ==========================================
  // PRODUCT QUANTITY BUTTONS
  // ==========================================
  document.querySelectorAll('.quantity-selector').forEach((selector) => {
    const input = selector.querySelector('input[type="number"]');
    const buttons = selector.querySelectorAll('button[type="button"]');
    if (!input || buttons.length < 2) return;

    buttons[0].addEventListener('click', () => {
      const min = parseInt(input.getAttribute('min') || '1', 10);
      const current = parseInt(input.value || min, 10);
      input.value = Math.max(min, current - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    buttons[1].addEventListener('click', () => {
      const current = parseInt(input.value || '1', 10);
      input.value = current + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

});
